import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/common";
import { TxTable } from "@/components/TxTable";
import { useApi, downloadBlob, errMsg } from "@/lib/api";

const ExcelButton = () => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await downloadBlob(api, "/exports/control.xlsx", `Control_ePlata_${new Date().toISOString().slice(0, 10).replace(/-/g, "")}.xlsx`); toast.success("Control Excel descargado"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <Button className="bg-teal-600 hover:bg-teal-700" disabled={busy} onClick={go} data-testid="export-excel-btn"><FileSpreadsheet className="mr-2 h-4 w-4" />{busy ? "Generando (puede tardar 1 min)…" : "Control Excel completo"}</Button>;
};

export default function Transactions() {
  const [f, setF] = useState({ q: "", tipo: "all", estado: "all", desde: "", hasta: "" });
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const params = { q: f.q, desde: f.desde, hasta: f.hasta, tipo: f.tipo === "all" ? "" : f.tipo, estado: f.estado === "all" ? "" : f.estado };
  return (
    <>
      <PageHeader title="Transacciones históricas" subtitle="Movimientos SPEI de todas las cuentas e-Plata operadas vía STP"><ExcelButton /></PageHeader>
      <div className="grid gap-3 rounded-2xl border border-slate-200 bg-white p-4 md:grid-cols-5">
        <div className="space-y-1.5 md:col-span-2"><Label className="text-xs text-slate-500">Buscar</Label>
          <Input placeholder="Clave de rastreo, cliente, contraparte, CLABE…" value={f.q} onChange={(e) => set("q")(e.target.value)} data-testid="tx-search-input" /></div>
        <div className="space-y-1.5"><Label className="text-xs text-slate-500">Tipo</Label>
          <Select value={f.tipo} onValueChange={set("tipo")}><SelectTrigger data-testid="tx-filter-tipo"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Todos</SelectItem><SelectItem value="entrada">Entradas</SelectItem><SelectItem value="salida">Salidas</SelectItem></SelectContent></Select></div>
        <div className="space-y-1.5"><Label className="text-xs text-slate-500">Estado</Label>
          <Select value={f.estado} onValueChange={set("estado")}><SelectTrigger data-testid="tx-filter-estado"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Todos</SelectItem><SelectItem value="liquidada">Liquidada</SelectItem><SelectItem value="pendiente">Pendiente</SelectItem><SelectItem value="devuelta">Devuelta</SelectItem></SelectContent></Select></div>
        <div className="grid grid-cols-2 gap-2">
          <div className="space-y-1.5"><Label className="text-xs text-slate-500">Desde</Label><Input type="date" value={f.desde} onChange={(e) => set("desde")(e.target.value)} data-testid="tx-filter-desde" /></div>
          <div className="space-y-1.5"><Label className="text-xs text-slate-500">Hasta</Label><Input type="date" value={f.hasta} onChange={(e) => set("hasta")(e.target.value)} data-testid="tx-filter-hasta" /></div>
        </div>
      </div>
      <TxTable params={params} />
    </>
  );
}
